import React from 'react';
import { Link } from 'react-router-dom';
import { SidebarData } from './SidebarData';

function Sidebar() {
  return (
    <>
        <div className='side-menu'>
          <ul className='side-menu-items'>
            {SidebarData.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
    </>
  );
}

export default Sidebar;